import { UploadResource } from "./UploadResource"
import { fetchGet, ErrorCallback, fetchPost, fetchDelete } from "../common/Requests"
import API from "../common/API"
import Upload from "./Upload"

type FetchUploadCallback = (json: UploadResource) => void

export function fetchUpload(code: string, handleSuccess: FetchUploadCallback, handleError: ErrorCallback) {
  fetchGet(
    `${API.baseUrl}/api/uploads/${code}`,
    (json) => {
      if (json.mimeType) {
        handleSuccess(json as UploadResource)
      } else {
        handleError(404)
      }
    },
    handleError
  )
}

export function fetchUploadBySessionId(uuid: string, handleSuccess: FetchUploadCallback, handleError: ErrorCallback) {
  fetchGet(
    `${API.baseUrl}/api/uploads/by-session-id/${uuid}`,
    handleSuccess,
    handleError
  )
}

export function trackView(code: string, handleSuccess?: () => void, handleError?: ErrorCallback) {
  fetchPost(
    `${API.baseUrl}/api/uploads/${code}/views`,
    {
      referrer: document.referrer,
      source: 'web'
    },
    handleSuccess,
    handleError
  )
}

export function deleteUpload(upload: Upload, handleSuccess?: () => void, handleError?: ErrorCallback) {
  if (upload.links.delete) {
    fetchDelete(upload.links.delete, handleSuccess, handleError)
  } else {
    // If delete link is null or undefined, it means the current user does not have permissions to delete
    handleError(401)
  }
}

export function makePrivate(code: string, handleSuccess?: () => void, handleError?: ErrorCallback) {
  fetchPost(
    `${API.baseUrl}/pic/${code}/make-private`,
    null,
    handleSuccess,
    handleError
  )
}

export function sendEmail(
  code: string,
  emailAddress: string,
  formatMediaForInstagram: boolean,
  successCallback: () => void,
  errorCallback: ErrorCallback
) {
  fetchPost(
    `${API.baseUrl}/api/uploads/${code}/emails`,
    {
      emailAddress: emailAddress,
      formatMediaForInstagram: formatMediaForInstagram
    },
    successCallback,
    errorCallback
  )
}
